import React from 'react';
import { Container, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Seo from '../components/Seo';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 10, md: 16 }, textAlign: 'center' }}>
      <Seo title="Page Not Found" path="/404" noindex />
      <Typography
        sx={{
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: { xs: '5rem', md: '7rem' },
          color: 'primary.main',
          lineHeight: 1,
        }}
      >
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        Page not found
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: 480, mx: 'auto' }}>
        The page you're looking for may have been moved or no longer exists. Let's get
        you back on course.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
        <Button variant="contained" size="large" onClick={() => navigate('/')}>
          Back to Home
        </Button>
        <Button variant="outlined" size="large" onClick={() => navigate('/contact')}>
          Contact Us
        </Button>
      </Stack>
    </Container>
  );
};

export default NotFound;
